import { createAuthPredicates } from '@zg-rentals/auth-comet/mfa';
import { defineAuthProvider } from '@zg-rentals/auth-react/legacy';
import { RentalManagerUserInfoV2WebApiHandler_get_queryOptions } from '@zg-rentals/ts-rental-manager-api-client-react-query';

import { client as zgApiClient } from '../../http/zgApiClient';

import type { RentalManagerAuthCheckUserInfoWebApiDto } from '@zg-rentals/ts-rental-manager-api-client';

const client = zgApiClient.extend({ timeout: 10_000 });

export type User = RentalManagerAuthCheckUserInfoWebApiDto;

export const { hasInitiatedAuth, hasAuth } = createAuthPredicates<User>((user) => ({
  ...user,
  isLoggedIn: user.loggedIn,
}));

export const Auth = defineAuthProvider({
  queryOptions: () =>
    RentalManagerUserInfoV2WebApiHandler_get_queryOptions(
      {
        includeCanClaimFreeListings: true,
        includeCustomers: true,
        includeProfileImageUrl: true,
      },
      { httpClient: client },
    ),
  isAuthorized: hasInitiatedAuth,
});

export const { useAuth } = Auth;
